module.exports = __webpack_public_path__ + "assets/img/download-btn-377bc49d.png";